;(function(Backbone, EG, _) {
var progressBar, currentProgress = 0, captchaProgressTimer;

  function initialize(w,d,s,u,q,js,fjs,nds) {
    nds = w.ndsapi || (w.ndsapi = {});
    nds.config = {
      q: [],
      ready: function (cb) {
        this.q.push(cb)
      }
    };

    js = d.createElement(s);
    fjs = d.getElementsByTagName(s)[0];
    js.src = u;
    fjs.parentNode.insertBefore(js, fjs);
    js.onload = function () {
      nds.load(u);
    }
  }

    function initCaptcha(baseUrl) {
      initialize(window, document, "script", baseUrl);
      $('body').off('click', '#nucaptcha-audio-toggle-button-wrapper').on('click', '#nucaptcha-audio-toggle-button-wrapper', captchaModeToggle);
      $('body').off('click', '#nucaptcha-refresh-button-wrapper').on('click', '#nucaptcha-refresh-button-wrapper', getNewCaptcha);
      $('body').off('click','#audio-replay').on('click', '#audio-replay', replayAudio);
      if ($('#nucaptcha-answer').length) {
        analyticsOptions = {
          linkId: getAnalyticsKey('CAPTCHA_DISPLAYED'),
          linkObj: null
        };
        uitk.analytics.track('a', analyticsOptions);
      }
    };

    function getNewCaptcha() {
      var nci = nucaptcha.getInterface(1);
      nci.cmdGetANewChallenge();
      focusTextInput();
      if (nci.getPlayerMode() == nci.PLAYERMODE_AUDIO) {
        startAudio();
        if ($('#nucaptcha-answer').length) {
          analyticsOptions = {
            linkId: getAnalyticsKey('REFRESH_AUDIO_CAPTCHA'),
            linkObj: null
          };
          uitk.analytics.track('a', analyticsOptions);
        }
      } else {
        if ($('#nucaptcha-answer').length) {
          analyticsOptions = {
            linkId: getAnalyticsKey('REFRESH_CAPTCHA'),
            linkObj: null
          };
          uitk.analytics.track('a', analyticsOptions);
        }
      }
    }

    function replayAudio() {
      var nci = nucaptcha.getInterface(1);
      focusTextInput();
      if (nci.getPlayerMode() == nci.PLAYERMODE_AUDIO) {
        nci.cmdRefreshChallenge();
        startAudio();
        if ($('#nucaptcha-answer').length) {
          analyticsOptions = {
            linkId: getAnalyticsKey('REPLAY_AUDIO_CAPTCHA'),
            linkObj: null
          };
          uitk.analytics.track('a', analyticsOptions);
        }
      }

    }

    function startAudio() {
      resetAudioProgress();
      $('#player-mode-visual').removeClass("hidden");
      $('#player-mode-audio').addClass("hidden");
      var audioPlayer = $("audio#nucaptcha-media")[0];
      if (audioPlayer) {
        audioPlayer.controls = false;
        if (!audioPlayer.autoplay) {
          audioPlayer.play();
        }
      }
      captchaProgressTimer = setInterval(animateProgress, 50);
    }

    function resetAudioProgress() {
      currentProgress = 0;
      $("#captcha-progress-indicator").width(0);
      $("#captcha-progress-container").removeClass("hidden");
      if (captchaProgressTimer) {
        clearInterval(captchaProgressTimer);
      }
    }

    function captchaModeToggle() {
      var nci = nucaptcha.getInterface(1);
      nci.cmdTogglePlayerMode();
      if (nci.getPlayerMode() == nci.PLAYERMODE_AUDIO) {
        startAudio();
        if ($('#nucaptcha-answer').length) {
          analyticsOptions = {
            linkId: getAnalyticsKey('CAPTCHA_MODE_CHANGED'),
            linkObj: null
          };
          uitk.analytics.track('a', analyticsOptions);
        }
      } else {
        $("#captcha-progress-container").addClass("hidden");
        $('#player-mode-audio').removeClass("hidden");
        $('#player-mode-visual').addClass("hidden");
        if ($('#nucaptcha-answer').length) {
          analyticsOptions = {
            linkId: getAnalyticsKey('CAPTCHA_MODE_CHANGED'),
            linkObj: null
          };
          uitk.analytics.track('a', analyticsOptions);
        }
      }
      focusTextInput();
    }

    function focusTextInput() {
      $('#nucaptcha-answer').focus();
    }

    function animateProgress() {
      var audioPlayer = $("audio#nucaptcha-media")[0];
      if (audioPlayer && audioPlayer.duration) {
        // Safari returns duration as infinity for streaming audio. Setting duration as 8.6 based on multiple samples
        if (audioPlayer.duration == Infinity) {
          currentProgress = (audioPlayer.currentTime * 100) / 8.6;
        } else {
          currentProgress = (audioPlayer.currentTime * 100) / audioPlayer.duration;
        }

        $("#captcha-progress-indicator").width(currentProgress + "%");
      }
      if (currentProgress >= 100) {
        currentProgress = 0;
        clearInterval(captchaProgressTimer);
      }
    }

  function getAnalyticsKey(key) {
    if(EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)){
      return EG.Users.Profile.Analytics.selfRegistrationViaCompany.guest[key];
    }
    return EG.Users.Profile.Analytics.selfRegistrationViaCompany[key];
  }

 EG.Users.Utils.InitCaptcha = initCaptcha;

})(Backbone, EG, _);

